import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { ImageOverlay } from "../../../../elements/element/Image/ImageOverlay";
import ArchiveContainer from "../../../../../file/containers/ArchiveContainer";
import { deepClone } from "../../../../../helpers/objectHelper";
import { largeHeaderImageHandler } from "./LargeHeaderImage.handler";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { HtmlWrapper } from "../../components/HtmlWrapper";
import "./LargeHeaderImage.css";
import InlineCropper from "../../../../../file/plugins/InlineCropper";
import { Cropper } from "../../../../../file/plugins/Cropper";
const LargeHeaderImage = (props) => {
  const [mediaVaultOpen, openMediaVault] = useState(false);
  const [isCropping, toggleCropper] = useState(false);
  const { content, style } = props.element;
  const { template } = props;
  const imgRef = useRef();
  const wrapperRef = useRef();
  const setImage = (source, openCropper = true) => {
    const { element, dispatch } = props;
    const updatedElement = deepClone(element);
    try {
      updatedElement.style.elementProps.source = source;
    } catch (error) {
      console.log("ERR: COULD NOT SET IMAGE");
    }
    updatedElement.content = largeHeaderImageHandler.elementEditor(updatedElement.style, null);
    props.dispatch(emailActions.updateEmailElement(updatedElement, null, true, props.inherit));
  /*   if (openCropper) toggleCropper(true); */
  };
  const onCrop = (value) => {
    setImage(value, false);
    toggleCropper(false);
  };
  const toggleMediaVault = (show) => {
    openMediaVault(show);
  };
  return (
    <React.Fragment>
      <tr ref={wrapperRef}>
        {isCropping ? (
          <td>
            <div
              style={
                isCropping
                  ? { margin: "0px auto 0px auto" }
                  : {
                      width: !isCropping && 0,
                      opacity: !isCropping && 0,
                      height: !isCropping && 0,
                      maxHeight: style.styleProps.height,
                    }
              }
            >
              <Cropper
                display={isCropping}
                source={style.elementProps.source}
                hideOverlay={isCropping}
                bgColor={template && template && template.content.content.backgroundColor}
                mailCrop={true}
                settings={{
                  type: "FULL",
                  alignment: "center",
                  style: {
                    maxHeight: 500,
                    width: style.elementProps.width,
                  },
                }}
                wrapperRef={wrapperRef}
                size={{ width: imgRef.current?.clientWidth, height: imgRef.current?.clientHeight }}
                viewport={{ height: style.elementProps.height, width: 680 }}
                toggle={() => toggleCropper(!isCropping)}
                parent={"contentId"}
                isCropping={isCropping}
                onSave={onCrop}
              />
            </div>
          </td>
        ) : null}
        {!isCropping ? (
          <td className="email-image-wrapper" ref={imgRef}>
            <HtmlWrapper content={content} />
            <ImageOverlay toggleMediaVault={toggleMediaVault} toggleCroppie={toggleCropper} isCroppable={style.elementProps.source !== largeHeaderImageHandler.defaultStyle().elementProps.source} />
          </td>
        ) : null}
      </tr>
      {/* <tr>
                <td className="email-image-wrapper">
                    <HtmlWrapper content={content} />
                    <ImageOverlay
                        toggleMediaVault={toggleMediaVault}
                        toggleCroppie={toggleCropper}
                        isCroppable={style.elementProps.source !== largeHeaderImageHandler.defaultStyle().elementProps.source}
                    />
                </td>
            </tr> */}
      <tr>
        <td>{mediaVaultOpen ? <ArchiveContainer isOpen={mediaVaultOpen} onUseSelected={setImage} showLaunchBtn={false} toggle={toggleMediaVault} /> : null}</td>
      </tr>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    template: state.template.template,
    inherit: state.email.inherit,
  };
}
export default connect(mapStateToProps)(LargeHeaderImage);
